import { TileLayer } from 'react-leaflet';

// Branded Mapbox style shared by every product / planner / preview map.
// V2 parity: the legacy frontend rendered this exact custom style
// (`lumera8/<styleId>`, 256px @2x retina tiles) on all three maps. The
// style id is overridable via env but defaults to the live V2 style so the
// look matches out of the box.
const MAPBOX_STYLE_ID =
  import.meta.env.VITE_MAPBOX_MAP_ID || 'cm8he6cne013z01qz5iaxfal1';
const MAPBOX_TOKEN = import.meta.env.VITE_MAPBOX_TOKEN;

const MAPBOX_ATTRIBUTION =
  '&copy; <a href="https://www.mapbox.com/">Mapbox</a> contributors';

// OSM fallback so the map still renders in dev / CI when no Mapbox token is
// configured (the branded style needs a `pk.*` token).
const OSM_URL = 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png';
const OSM_ATTRIBUTION =
  '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>';

// Single source of truth for the base tile layer across the product,
// planner and preview maps. Renders the branded Mapbox tiles (exact V2
// URL/attribution) when `VITE_MAPBOX_TOKEN` is set, else falls back to OSM.
// Legacy perf tuning (V2 parity): don't reload tiles on every zoom frame
// and only fetch once the map settles — smoother pans/zooms with many
// markers. Leaflet reads these on the (grid) tile layer.
const PERF = { updateWhenIdle: true, updateWhenZooming: false } as const;

export const BaseTileLayer = () =>
  MAPBOX_TOKEN ? (
    <TileLayer
      attribution={MAPBOX_ATTRIBUTION}
      url={`https://api.mapbox.com/styles/v1/lumera8/${MAPBOX_STYLE_ID}/tiles/256/{z}/{x}/{y}@2x?access_token=${MAPBOX_TOKEN}`}
      {...PERF}
    />
  ) : (
    <TileLayer attribution={OSM_ATTRIBUTION} url={OSM_URL} {...PERF} />
  );
